import styled from 'styled-components';

export const StyledEditWrapper = styled.div``;
